import React, { Component } from "react";
import Button from "../../../../shared/button/button";
import { withGetScreen } from "react-getscreen";

class Steps extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			canPrev,
			prev,
			next,
			canNext,
			prevText,
			nextText,
			children,
			dataActionNext,
			dataActionPrev
		} = this.props;

		return (
			<div className="col-xs-16 steps">
				<Button
					className={`btn-prev ${!canPrev ? "step-inactive" : ""}`}
					onClick={() => prev()}
					type="button"
					style={!prev ? { visibility: "hidden" } : {}}
					data-action={dataActionPrev ? dataActionPrev : "steps-prev"}
				>
					<i className="icon-double-left" /> {prevText || "Anterior"}
				</Button>
				{children ? children : <p />}
				<Button
					className={`btn btn-success btn-next ${!canNext ? "step-inactive" : ""}`}
					onClick={() => next()}
					disabled={!canNext || !next}
					type="button"
					data-action={dataActionNext ? dataActionNext : "steps-next"}
				>
					{nextText || "Próximo"} <i className="icon-double-right" />
				</Button>
			</div>
		);
	}
}

export default withGetScreen(Steps, {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
